import React from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import { MAX_MOBILE_THRESHOLD } from '~/core/constants'

const Subtext = styled.div`
  font-size: 12px;
  color: #5e6d7a;
  text-align: center;
  margin: 24px 24px 48px;
  
  @media screen and (min-width: ${MAX_MOBILE_THRESHOLD}) {
    margin-bottom: 64px; 
  }
`

export default () => (
  <Subtext>{translate('mau_details')}</Subtext>
)
